import { TableCell, TableRow, IconButton } from "@mui/material";
import "../styles/table-combobox.scss";
import { Edit, Delete } from '@mui/icons-material';


export const CategoriesTasksTableRow = (props) => {
    const { category, setShowEditForm, setEditedCategory, setShowDialogDelete } = props;

    const editCategory = (event, category) => {
        setShowEditForm(true);
        setEditedCategory(category);
    };

    const deleteCategoryButtonClick = (event, category) => {
        setEditedCategory(category);
        setShowDialogDelete(true);
    };

    return (
        <TableRow key={category.id} hover={true}>
            <TableCell>{category.name}</TableCell>
            <TableCell>{category.bitrix_code}</TableCell>
            <TableCell>{category.default_volume}</TableCell>
            <TableCell align="center">
                <div style={{ display: 'flex' }}>
                    <IconButton onClick={(event) => editCategory(event, category)} sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}>
                        <Edit sx={{ fontSize: 20 }} />
                    </IconButton>
                    <IconButton onClick={(event) => deleteCategoryButtonClick(event, category)} sx={{ padding: 0, marginLeft: 1, marginRight: 1 }}>
                        <Delete sx={{ fontSize: 20 }} />
                    </IconButton>
                </div>
            </TableCell>
        </TableRow>
    )
}